import { GetFormRolesQuery, GetFormRolesQueryVariables } from '@/typings/domain'
import apolloClient from './apolloClient'
import GetFormRolesGQL from './graphql/GetFormRoles.graphql'

export function getFormRoles({ formToken, after, first }: GetFormRolesQueryVariables) {
  return apolloClient.query<GetFormRolesQuery, GetFormRolesQueryVariables>({
    query: GetFormRolesGQL,
    variables: { formToken, after, first },
    fetchPolicy: 'no-cache',
  })
}
